export { default as Tabs } from "./components/Tabs";
export { default as TabList } from "./components/TabList";
export { default as Tab } from "./components/Tab";
export { default as TabPanel } from "./components/TabPanel";